import React from 'react';
import BetaLandingPage from './BetaLandingPage';
import PrivacyPolicy from './PrivacyPolicy';
import TermsOfUse from './TermsOfUse';
import AdminInbox from './AdminInbox';
import ErrorBoundary from './ErrorBoundary';

function App() {
  const path = window.location.pathname;

  let Page;
  if (path === '/privacy') {
    Page = PrivacyPolicy;
  } else if (path === '/terms') {
    Page = TermsOfUse;
  } else if (path === '/admin') {
    Page = AdminInbox;
  } else {
    Page = BetaLandingPage;
  }

  return (
    <ErrorBoundary>
      <Page />
    </ErrorBoundary>
  );
}

export default App;
